var render = function render(_c,_vm){return _c('div',{staticClass:"badgeContainer"},[_c('div',{staticClass:"el-badge"},[_c('sup',{staticClass:"badge"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }